// extracted by mini-css-extract-plugin
export default {"button":"InterviewsTable-module__button__z1Y-D","startInterviewButton":"InterviewsTable-module__startInterviewButton__4FnX0"};